<template>
  <div class="asc-role-container">
    <div>
      <v-row>
        <v-col
          ><asc-surface-title
            class="asc-role-mgmt-wrapper--title"
            title="Role Management"
        /></v-col>
        <v-col>
          <template v-if="mappedGroupData.length">
            <asc-accent-button
              class="asc-role-container--button"
              button-text="Add Role"
              :on-click="handleAddRole"
            ></asc-accent-button>
          </template>
        </v-col>
      </v-row>
    </div>
    <div class="asc-role-container--template">
      <asc-role-grid-template
        title="Role Management"
        :values="mappedGroupData"
        :on-add-role="handleAddRole"
        :on-open="onRowClick"
      ></asc-role-grid-template>

      <asc-role-dialog
        :show-dialog="showEditDialog"
        :name="title"
        :role="editRole"
        :edit="edit"
        :loading="dialogLoading"
        :title="title"
        :mapped-resource-data="mappedResourceData"
        :on-close="onCloseEditDialog"
        :all-resource-modules="allResourceModules"
        @submitApply="submitApply"
        @gridCheckboxToggle="handleGridCheckboxToggle"
      ></asc-role-dialog>
    </div>
  </div>
</template>

<script>
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle.vue'
import AscRoleGridTemplate from '@/components/templates/AscRoleGridTemplate.vue'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscRoleDialog from '@/components/molecules/AscRoleDialog'
import {
  ROLE_MANAGEMENT_CONSTS as RM,
  AIRLINE_MANAGEMENT_CONSTS as AOC,
} from '@/stores/consts'
import { mapActions, mapState } from 'vuex'
import { union } from '@/utilities/array'

export default {
  name: 'AscRoleContainer',
  components: {
    AscSurfaceTitle,
    AscRoleGridTemplate,
    AscAccentButton,
    AscRoleDialog,
  },
  data() {
    return {
      showEditDialog: false,
      dialogLoading: false,
      title: '',
      edit: false,
      editRole: {
        resources: [],
      },
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(RM.NAMESPACE, [
      'rolesData',
      'allRoleDataLoading',
      'allResources',
      'allResourceModules',
      'singleRole',
    ]),
    ...mapState(AOC.NAMESPACE, ['allAirlines']),

    mappedGroupData() {
      return this.rolesData.map(m => {
        return {
          id: m.id,
          name: m.name,
          description: m.description,
          airlineName: this.allAirlines.find(
            f => f.isActive && f.id === m.airlineId,
          )
            ? this.allAirlines.find(f => f.isActive && f.id === m.airlineId)
                .name
            : '',
        }
      })
    },

    mappedResourceData() {
      const allResourcesValues = this.allResources.map(m => {
        return {
          displayName: m.displayName,
          id: m.id,
          resourceModuleId: m.resourceModuleId,
          readPermission: false,
          editPermission: false,
          deletePermission: false,
          existing: false,
        }
      })

      const unionArray = union(this.editRole.resources, allResourcesValues)

      return unionArray
    },
  },

  created() {
    this.getGroupsData()
  },

  methods: {
    ...mapActions(RM.NAMESPACE, [
      RM.GET_ALL_ROLES,
      RM.SAVE_ROLE_DETAILS,
      RM.GET_ALL_RESOURCES,
      RM.GET_SINGLE_ROLE,
      RM.UPDATE_SINGLE_ROLE,
      RM.UPDATE_ROLE_DETAILS,
    ]),
    ...mapActions(AOC.NAMESPACE, [AOC.GET_ALL_AIRLINES]),

    async getGroupsData() {
      await Promise.all([
        this[RM.GET_ALL_ROLES](),
        this[AOC.GET_ALL_AIRLINES](),
        this[RM.GET_ALL_RESOURCES](),
      ])
    },
    handleAddRole() {
      this.title = 'New Role'
      this.edit = false
      this.editRole = {
        resources: [],
      }
      this.showEditDialog = true
      this.dialogLoading = false
    },
    async addRole(role) {
      await this[RM.SAVE_ROLE_DETAILS]({
        name: role,
        description: '',
        airlineId: null,
      })
    },
    async onRowClick(data) {
      console.log('onRowClick', data)
      this.title = 'Edit Role'
      this.edit = true
      this.showEditDialog = true
      this.dialogLoading = true
      await Promise.all([this[RM.GET_SINGLE_ROLE](data.id)])
      this.editRole = this.singleRole
      this.dialogLoading = false
    },
    async submitApply(role, resources) {
      if (role.resources) {
        const unionArray = union(resources, role.resources)

        role.resources = unionArray
      } else {
        role.resources = resources
      }

      if (this.edit) {
        await this[RM.UPDATE_ROLE_DETAILS](role)
      } else {
        await this[RM.SAVE_ROLE_DETAILS](role)
      }
    },
    onCloseEditDialog() {
      this.showEditDialog = false
      this.edit = false
      this.editRole = {
        resources: [],
      }
    },
    async handleGridCheckboxToggle(val) {
      const newSingleRole = this.singleRole

      const tmpArray = [val]

      const unionArray = union(tmpArray, this.singleRole.resources)

      newSingleRole.resources = unionArray

      //await this[RM.UPDATE_SINGLE_ROLE](newSingleRole)
    },
    async handleRoleCreate() {
      await this[RM.SAVE_ROLE_DETAILS](this.singleRole)
    },
    async handleRoleUpdate() {
      console.log(this.singleRole)
      await this[RM.UPDATE_ROLE_DETAILS](this.singleRole)
    },
  },
}
</script>

<style lang="scss">
.asc-role-container {
  &--button {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
  }
  &--template {
    padding-bottom: 12px;
  }

  .asc-role-mgmt-wrapper {
    &--title {
      padding-top: 10px;
      vertical-align: center;
    }
  }
}
</style>
